<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<h1>Payment Terms Setup</h1>
<main>
  <div class="instruction-text">
    Admin access to add or update payment terms for your organization. Only an authorized user may set these terms. Use the information below to manage standard and monthly payment terms. These terms
    are used for vendors and customers.
  </div>
  <div>
    <div class="p-col-12">

      <app-data-table [columns]="tableColumns" [value]="paymentTerms" sortField="paymentTermsName" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                      [rightCaptionTemplate]="rightCaptionTemplate">

        <ng-template #rightCaptionTemplate>
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4" style="text-align:right;">
              <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Add Payment Term"
                      (click)="onClickAddPaymentTerm()">
              </button>
            </div>
          </div>
        </ng-template>

        <ng-template #actionTemplate let-row="row">
          <button *ngIf="row.orgId===DefaultOrg.OrgId" pButton type="button" class="icon-action" icon="fa fa-clone" pTooltip="Override" tooltipPosition="top"
                  (click)="onClickOverridePaymentTerm(row)">
          </button>
          <button *ngIf="row.orgId!==DefaultOrg.OrgId" pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Update" tooltipPosition="top"
                  (click)="onClickEditPaymentTerm(row)">
          </button>
        </ng-template>
      </app-data-table>

    </div>

    <p-dialog *ngIf="paymentTermsDialog" [(visible)]="paymentTermsDialog"
              [header]="paymentTermChangeType" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40">
      <form #dialogForm="ngForm">

        <p *ngIf="errorMessageForSameTermName" class="growl-submit">{{errorMessageForSameTermName}}</p>
        <div class="p-grid">
          <div class="p-col-12 p-md-3 p-lg-3">
            <label>Term Type*</label>
          </div>
          <div class="p-col-12 p-md-9 p-lg-9">
            <p-dropdown id="paymentTerm" name="payTerm" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                        [options]="paymentTermsTypesDropdown"
                        [(ngModel)]="paymentTermToEdit.paymentTermType"
                        [disabled]="paymentTermChangeType===PaymentTermChangeType.Override || (paymentTermToEdit && paymentTermToEdit.id)" required></p-dropdown>
          </div>
        </div>
        <div *ngIf="paymentTermToEdit.paymentTermType === PaymentTermType.Standard" class="p-grid">
          <div class="p-col-12 p-md-3 p-lg-3">
            <label>Term Name*</label>
          </div>
          <div class="p-col-12 p-md-9 p-lg-9">
            <input pInputText id="nameStd" name="nameStd" type="text"
                   [size]="Validation.TermNameMaxLength" [maxlength]="Validation.TermNameMaxLength"
                   [(ngModel)]="paymentTermToEdit.standardTermName"
                   (input)="isDuplicateTermName(paymentTermToEdit.standardTermName)"
                   [disabled]="paymentTermChangeType===PaymentTermChangeType.Override" required>

            <button pButton type="button" class="help-tip" icon="fa fa-info-circle"
                    pTooltip="If you override a standard term, changing this term's name will cause the original term to reappear in the table. (ex: You override 'COD', make changes to its terms and save it with a new name, the original term 'COD' will reappear)"
                    tooltipPosition="top"></button>
          </div>
          <div class="p-col-12">
            <div class="p-col-12 p-md-2 p-lg-2">
              <label>Rules*</label>
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-md-2 p-lg-2">
            </div>
            <div class="p-col-12 p-md-10 p-lg-10 term-line">
              Net due in
              <input pInputText name="daysDueAfterBill" type="text" [pattern]="patternFor2Digits" pKeyFilter="num"
                     [size]="Validation.DaysMaxLength" [maxlength]="Validation.DaysMaxLength" style="margin:0px 5px 5px 5px"
                     [(ngModel)]="paymentTermToEdit.daysDueAfterBill"> days after invoice or bill.
            </div>
            <div class="p-col-12 p-md-2 p-lg-2">
            </div>
            <div class="p-col-12 p-md-10 p-lg-10 term-line">
              Discount is
              <input pInputText name="standardDiscountIfPaidEarly" type="text" [pattern]="patternFor5DigitsDecimal"
                     [size]="Validation.DiscountMaxLength" [maxlength]="Validation.DiscountMaxLength" style="margin:0px 5px 5px 5px"
                     [(ngModel)]="paymentTermToEdit.discountIfPaidEarly"> % if paid
              within
              <input pInputText name="daysToPayForDiscount" type="text" [pattern]="patternFor2Digits"
                     [size]="Validation.DaysMaxLength" [maxlength]="Validation.DaysMaxLength" style="margin:0px 5px 5px 5px"
                     [(ngModel)]="paymentTermToEdit.daysToPayForDiscount">days of the invoice.
            </div>
            <div class="p-col-12 p-md-2 p-lg-2">
            </div>
            <div class="p-col-12 p-md-10 p-lg-10 term-line">
              Interest amount if paid past due date:
              <input pInputText name="standardPastDueInterestRate" type="text" [pattern]="patternFor5DigitsDecimal"
                     [size]="Validation.DiscountMaxLength" [maxlength]="Validation.DiscountMaxLength" style="margin:0px 5px 5px 5px"
                     [(ngModel)]="paymentTermToEdit.pastDueInterestRate">%
            </div>
          </div>
        </div>

        <div *ngIf="paymentTermToEdit.paymentTermType === PaymentTermType.Monthly" class="p-grid">
          <div class="p-col-12 p-md-3 p-lg-3">
            <label>Term Name*</label>
          </div>
          <div class="p-col-12 p-md-9 p-lg-9">
            <input pInputText name="monthlyName" type="text"
                   [size]="Validation.TermNameMaxLength" [maxlength]="Validation.TermNameMaxLength"
                   [(ngModel)]="paymentTermToEdit.monthlyTermName"
                   (input)="isDuplicateTermName(paymentTermToEdit.monthlyTermName)" required>
          </div>
          <div class="p-col-12">
            <div class="p-col-12 p-md-3 p-lg-2">
              <label>Rules*</label>
            </div>
          </div>

          <div class="p-col-12 p-md-2 p-lg-2">
          </div>
          <div class="p-col-12 p-md-10 p-lg-10 term-line">
            Net due before the
            <input pInputText name="dayofMonthBillDue" type="text" [pattern]="patternFor2Digits"
                   [size]="Validation.DaysMaxLength" [maxlength]="Validation.DaysMaxLength" style="margin:0px 5px 5px 5px"
                   [(ngModel)]="paymentTermToEdit.dayofMonthBillDue">
            th day of the month.
          </div>
          <div class="p-col-12 p-md-2 p-lg-2">
          </div>
          <div class="p-col-12 p-md-10 p-lg-10 term-line">
            Due next month if within
            <input pInputText name="dayofMonthForNextMonth" type="text" [pattern]="patternFor2Digits"
                   [size]="Validation.DaysMaxLength" [maxlength]="Validation.DaysMaxLength" style="margin:0px 5px 5px 5px"
                   [(ngModel)]="paymentTermToEdit.dayofMonthForNextMonth">
            days(s) of due date.
          </div>
          <div class="p-col-12 p-md-2 p-lg-2">
          </div>
          <div class="p-col-12 p-md-10 p-lg-10 term-line">
            Discount is
            <input pInputText name="discountIfPaidEarly" type="text" [pattern]="patternFor5DigitsDecimal"
                   [size]="Validation.DiscountMaxLength" [maxlength]="Validation.DiscountMaxLength" style="margin:0px 5px 5px 5px"
                   [(ngModel)]="paymentTermToEdit.discountIfPaidEarly">
            % if paid before
            <input pInputText name="dayOfMonthForDiscount" type="text" [pattern]="patternFor2Digits"
                   [size]="Validation.DaysMaxLength" [maxlength]="Validation.DaysMaxLength" style="margin:0px 5px 5px 5px"
                   [(ngModel)]="paymentTermToEdit.dayofMonthForDiscount">
            day of the month.
          </div>
          <div class="p-col-12 p-md-2 p-lg-2">
          </div>
          <div class="p-col-12 p-md-10 p-lg-10 term-line">
            Interest amount if paid past due date:
            <input pInputText name="pastDueInterestRate" type="text" [pattern]="patternFor5DigitsDecimal"
                   [size]="Validation.DiscountMaxLength" [maxlength]="Validation.DiscountMaxLength" style="margin:0px 5px 5px 5px"
                   [(ngModel)]="paymentTermToEdit.pastDueInterestRate">
            %
          </div>
        </div>
      </form>

      <p-footer>
        <div class="p-col-12 ui-dialog-buttonpane ui-helper-clearfix" style="text-align:right;">
          <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
                  (click)="paymentTermsDialog = false"></button>
          <button *ngIf="!paymentTermToEdit.id" pButton type="button" class="button-action" icon="fa fa-check" label="Save"
                  (click)="saveOrUpdatePaymentTerm(paymentTermToEdit)"
                  [disabled]="!dialogForm.form.valid || errorMessageForSameTermName"></button>
          <button *ngIf="paymentTermToEdit.id"
                  pButton type="button" class="button-action" icon="fa fa-check" label="Update"
                  (click)="saveOrUpdatePaymentTerm(paymentTermToEdit)"
                  [disabled]="!dialogForm.form.valid || errorMessageForSameTermName"></button>
        </div>
      </p-footer>

    </p-dialog>
  </div>
  <div class="main-clear"></div>
</main>
